import { ADD_AI_INVOICE, UPDATE_AI_INVOICE, DELETE_AI_INVOICE } from "./actionType"

export const addAIInvoice = invoice => ({
  type: ADD_AI_INVOICE,
  payload: invoice,
})

export const updateAIInvoice = invoice => ({
  type: UPDATE_AI_INVOICE,
  payload: invoice,
})

export const deleteAIInvoice = id => ({
  type: DELETE_AI_INVOICE,
  payload: id,
})
